import React, { Fragment } from 'react';

import Constants from '../../../../../Constants';

import Textarea from '@usas/ui-web/components/inputs/Textarea';
import CurrencyInput from '@usas/ui-web/components/inputs/CurrencyInput';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import LscDropdown from '@usas/ui-web/components/dropdowns/lscDropdown/LscDropdown';
import OfferingTypeRegistrationRadiobuttonList from '@usas/ui-web/components/radiobuttonlists/offeringType/OfferingTypeRegistrationRadiobuttonList';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import Input from '@usas/ui-web/components/inputs/Input';

const ClubRegistrationApprovalForm = ({ isRevisit, clubRegObj, stateObj, formState, errorState, onFormValueChanged, onDownloadApplication, onValueTextPairChanged, step }) => {
  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12 col-sm-6">
          <div>
            <strong>LSC - Club Name/Club Code: </strong>
            {`${clubRegObj.lscCode || ''} - ${clubRegObj.clubName || ''}/${clubRegObj.clubCode || ''}`}
          </div>
          <div>
            <strong>Submission Date: </strong>
            {formatDate(clubRegObj.submissionDate)}
          </div>
          <div>
            <strong>Club Registration Type: </strong>
            {clubRegObj.offeringName}
          </div>
          <div>
            <strong>Club Registration Completed By: </strong>
            {clubRegObj.completedByFirstName} {clubRegObj.completedByLastName}
          </div>

          {step === "HQ" &&
            <>
              <div className='row usas-extra-top-margin'>
                <div style={{ paddingLeft: '15px' }}>
                  <hr></hr>
                  <p><h3>HQ Admin Overrides </h3></p>
                  <div style={{ marginTop: '15px' }}>
                    <strong>Club Selected LSC: </strong>
                    {clubRegObj.lscCode}
                  </div>
                  <LscDropdown
                    label="Override LSC*"
                    name="lscId"
                    value={formState.lscId}
                    error={errorState.lscId}
                    message={errorState.lscId}
                    onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'lscId', newValueLabel, 'lscName', e); }}
                    isCurrent={true}
                  />
                </div>
                <div className='usas-extra-top-margin' style={{ paddingLeft: '15px' }}>
                  <p><strong>You must select an LSC to change the Offering Type</strong></p>
                </div>
                {formState.lscName !== "--" && formState.lscName !== "" &&
                  <div className='usas-extra-top-margin' style={{ paddingLeft: '15px' }}>
                    <OfferingTypeRegistrationRadiobuttonList
                      label={`Select a Offering Type`}
                      name={"offeringInstanceId"}
                      error={errorState.offeringInstanceId}
                      message={errorState.offeringInstanceId}
                      value={formState.offeringInstanceId}
                      isVertical={true}
                      onChange={(value) => { onFormValueChanged('offeringInstanceId', parseInt(value)) }}
                      orgUnitId={formState.lscId}
                      // orgUnitId={clubRegObj.orgUnitId}
                      isOrganizationRegistration={false}
                    />
                  </div>
                }
              </div>
              <div className='row usas-extra-top-margin'>
                <div className="col-xs-12 col-sm-12">
                  <CurrencyInput
                    label={'Fee Amount Override'}
                    value={formState.feeAmount}
                    error={errorState.feeAmount}
                    message={errorState.feeAmount}
                    name={'feeAmount'}
                    onChange={value => onFormValueChanged('feeAmount', value)} />
                    <br />
                    <span style={{color: '#202020'}}>Leave this value set to $0 if you want to accept the default USA Swimming Fee for the selected Offering Type</span>
                </div>
              </div>
              <div className='row usas-extra-top-margin'>
                <div>
                  <hr></hr>
                </div>
              </div>
            </>
          }
        </div>
        <div className="col-xs-12 col-sm-6">
          <ActionIntraPageButton className="pull-right" type="button" onClick={() => onDownloadApplication()}>
            {Constants.WORKFLOW_APPLICATION_TEXT}
          </ActionIntraPageButton>
        </div>
        <div className="col-xs-12" style={{ marginTop: '15px' }}>
          {isRevisit === true ?
            <div className='usas-extra-bottom-margin'>
              <hr></hr>
              <strong>Notes: </strong>
              {stateObj?.workflowStep?.map(x => {
                let workFlowStepCopySortedFiltered = JSON.parse(JSON.stringify(stateObj?.workflowStep)).sort(
                  (a, b) => b.stepItteration - a.stepItteration).filter(y => y.workflowStepId !== x.workflowStepId);

                if (!workFlowStepCopySortedFiltered?.find(
                  z => z.workflowTypeStepId === x.workflowTypeStepId && z.workflowId === x.workflowId && z.stepStatus === 'Approved')) {
                  return (
                    { ...x }
                  )
                }
              }).sort((a, b) => b.stepItteration - a.stepItteration)?.find(step => step.stepStatus === 'Revisit')?.stepNotes || ''}
            </div>
            :
            <Textarea
              className={global.Textarea}
              label="Notes:"
              name="stepNotes"
              value={formState.stepNotes}
              error={errorState.stepNotes}
              message={errorState.stepNotes}
              makeLabelBold={true}
              onChange={value => onFormValueChanged('stepNotes', value)} />}
        </div>
      </div>
    </Fragment >
  );
}

export default ClubRegistrationApprovalForm;